import React from 'react';
import { ModuleWithImage } from '../module-with-image';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import HomepageModuleWrapper from '../homepage-module-wrapper/homepage-module-wrapper';
import type { IModuleWithImageData } from '../../../../dotcms/dotcms-models/dotcms-module-with-image';
import { Page } from '../../../../app/page-url-path';

interface IProps {
  data: IModuleWithImageData;
}

const WhatIsEsppModule: React.FC<IProps> = ({ data }) => (
  <HomepageModuleWrapper dataComponentName="WhatIsEsppModule">
    <ModuleWithImage
      data={data}
      button={{
        pageForButton: {
          defaultData: Page.RESOURCE_LIBRARY,
        },
        dataElementId: DataElementId.HOMEPAGE_LINK_WHAT_IS_ESPP,
      }}
    />
  </HomepageModuleWrapper>
);

export default WhatIsEsppModule;
